const pageNameKey = "gatewaysListView";

export const gatewaysListViewEn = {
  [pageNameKey]: {
    subtitle: "Gateways List",
    addGatewayButton: "Add Gateway",
  },
};

export const gatewaysListViewPtBr = {
  [pageNameKey]: {
    subtitle: "Lista de gateways",
    addGatewayButton: "Adicionar gateway",
  },
};

export const gatewaysListViewDe = {
  [pageNameKey]: {
    subtitle: "Gateways-Liste",
    addGatewayButton: "Gateway hinzufügen",
  },
};

export const gatewaysListViewZhHans = {
  [pageNameKey]: {
    subtitle: "网关列表",
    addGatewayButton: "添加网关",
  },
};

export const gatewaysListViewIt = {
  [pageNameKey]: {
    subtitle: "Elenco gateway",
    addGatewayButton: "Aggiungi gateway",
  },
};

export const gatewaysListViewEs = {
  [pageNameKey]: {
    subtitle: "Lista de gateways",
    addGatewayButton: "Agregar gateway",
  },
};

export const gatewaysListViewNl = {
  [pageNameKey]: {
    addGatewayButton: "Gateway toevoegen",
    subtitle: "Gatewaylijst",
  },
};

export const gatewaysListViewTr = {
  [pageNameKey]: {
    addGatewayButton: "Ağ Geçidi Ekle",
    subtitle: "Ağ Geçitleri Listesi",
  },
};
